/**
 * The Delete Customer confirmation copy + blocking rules, shared by the Customer listing's row
 * menu and the Customer Detail header (AC 102103: "the same Delete Customer rules apply as
 * previously defined"). Spread into `useDeleteConfirm` alongside that surface's own `remove`
 * mutation — the copy is shared, the mutation and any post-delete navigation are not.
 *
 * The two blocked codes are the backend's (102101) and **both** block deletion: a Customer with
 * an active Subscription, or one with an open Order.
 */
export const CUSTOMER_DELETE_CONFIRM = {
  noun: 'Customer',
  body: 'Are you sure you want to delete this customer?',
  blockedCode: ['CUSTOMER_HAS_ACTIVE_SUBSCRIPTION', 'CUSTOMER_HAS_OPEN_ORDERS'],
  blockedTitle: 'Oops Sorry!',
  blockedBody: 'This customer cannot be deleted with Active Subscription/Order',
  blockedCloseText: 'Close',
  errorFallback: 'Failed to delete customer. Please try again.',
} as const;
